<form class="job-selection-dialog-content">
    <cds-form-group layout="vertical">
        <cds-input controlWidth="shrink">
            <label>Name</label>
            <input name="name" [(ngModel)]="name" />
        </cds-input>
        <app-multi-select-box
            [title]="'Markers'"
            [items]="markers$ | async"
            (selected)="selectMarkers($event)"
        ></app-multi-select-box>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="goBack()">Back</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start Job</cds-button>
</div>
